export const hierarchies = [
    { label: 'Category', value: 'category' },
    { label: 'Super-Category', value: 'supercategory' },
    { label: 'Department', value: 'department' },
    { label: 'Total Store', value: 'totalstore' },
];
